import { render } from "./Usage.vue?vue&type=template&id=d49c8424&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=js"
export * from "./Usage.vue?vue&type=script&lang=js"

import "./Usage.vue?vue&type=style&index=0&id=d49c8424&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d49c8424"]])

export default __exports__